import React, { memo, SVGProps } from 'react'

export const Clock = memo((props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 20C7.59385 20 4 16.4062 4 12C4 7.59385 7.59385 4 12 4C16.4062 4 20 7.59385 20 12C20 16.4062 16.4062 20 12 20ZM5.84618 12C5.84618 8.6031 8.6031 5.84618 12 5.84618C15.3969 5.84618 18.1539 8.6031 18.1539 12C18.1539 15.3969 15.3969 18.1539 12 18.1539C8.6031 18.1539 5.84618 15.3969 5.84618 12ZM12 12.9231H15.0523C15.557 12.9231 15.9754 12.5046 15.9754 12C15.9754 11.4954 15.557 11.0769 15.0523 11.0769H12.9231V8.2831C12.9231 7.77849 12.5046 7.36003 12 7.36003C11.4954 7.36003 11.0769 7.77849 11.0769 8.2831V12C11.0769 12.5046 11.4954 12.9231 12 12.9231Z"
      fill="currentColor"
    />
  </svg>
))
